<section class="signupSection">
  <form [formGroup]="signUp">
    <mat-form-field appearance="outline" class="col-md-12" floatLabel="always">
      <mat-label>Enter Your Full Name</mat-label>
      <mat-icon matPrefix>person_outline</mat-icon>
      <input matInput placeholder="Enter Your Full Name" formControlName="name" maxlength="25" restrictTo valType="charOnly">
      <mat-error *ngIf="signUp.controls['name'].hasError('required')"><strong>Full Name</strong> is required.</mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-md-12" floatLabel="always">
      <mat-label>Email Address</mat-label>
      <mat-icon matPrefix>mail_outline</mat-icon>
      <input matInput placeholder="Enter Your Email Address" formControlName="email" minlength="3" maxlength="48" appDisableCopyPaste appLowercaseInput>
      <mat-error *ngIf="signUp.controls['email'].hasError('required')"><strong>Email Address</strong> is required.</mat-error>
      <mat-error *ngIf="signUp.controls['email'].hasError('pattern')">Enter a valid <strong>Email Address</strong>.</mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-md-12" floatLabel="always">
      <mat-label>Enter Your Mobile Number</mat-label>
      <mat-icon matPrefix>local_phone</mat-icon>
      <input matInput placeholder="Enter Your Mobile Number" formControlName="mobile" maxlength="10" minlength="10" restrictTo valType="spaceNotUse" valType="numberOnly" appDisableCopyPaste>
      <mat-error *ngIf="signUp.controls['mobile'].hasError('required')"><strong>Mobile Number</strong> is required.</mat-error>
      <mat-error *ngIf="signUp.controls['mobile'].hasError('pattern')">Enter a valid <strong>Mobile Number</strong>.</mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-md-12" floatLabel="always">
      <mat-label>Enter Your Password</mat-label>
      <mat-icon matPrefix>lock_outline</mat-icon>
      <input matInput placeholder="Enter Your Password" [type]="hide ? 'password' : 'text'" formControlName="password" minlength="8" restrictTo valType="spaceNotUse" appDisableCopyPaste>
      <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide" ><mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon></button>
      <mat-error *ngIf="signUp.controls['password'].hasError"><strong>Password</strong> is required.</mat-error>
      <mat-hint align="end" [matMenuTriggerFor]="pass_hint"><mat-icon>info</mat-icon></mat-hint>
      <mat-menu #pass_hint="matMenu" xPosition="before">
        <ul>
          <li>Password must be a minimum 8 characters</li>
          <li>Must be use <span>lowercase</span>, <span>an uppercase</span> and <span>a number</span></li>
          <li>Must be use <span>Symbols</span></li>
          <li>Ex. - (Cheaptickets&#x40;123)</li>
        </ul>
      </mat-menu>
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-md-12" floatLabel="always">
      <mat-label> Confirm Password</mat-label>
      <mat-icon matPrefix>lock_outline</mat-icon>
      <input matInput placeholder=" Confirm Password" [type]="confirmPasshide ? 'password' : 'text'" formControlName="repeat_password" minlength="8" restrictTo valType="spaceNotUse" appDisableCopyPaste>
      <button mat-icon-button matSuffix (click)="confirmPasshide = !confirmPasshide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="confirmPasshide"><mat-icon>{{confirmPasshide ? 'visibility_off' : 'visibility'}}</mat-icon></button>
      <mat-error *ngIf="signUp.hasError('required')">Please re-enter your password.</mat-error>
      <mat-error>Both the password must match</mat-error>
    </mat-form-field>
    <p>By signing in, I understand & agree to Belairtrip <a href="/terms-and-conditions" target="_blank">Terms of Use</a> and <a href="/privacy-policy" target="_blank">Privacy Policy.</a></p>

    <button mat-button class="secoundaryBtn" (click)="submit()">Sign up</button>
  </form>
  <div class="messageArea text-start" *ngIf="this.listItem">
    <p class="denger" [ngClass]="this.listItem === 'Successfully registered, please login' ? 'success' : ''">{{this.listItem | titlecase}}</p>
  </div>
    <!-- <h3><span>Or</span></h3>
    <div class="loginButton">
        <button mat-button class="google">
            <img src="../../../assets/b2c/hotel/google.png" class="img-fluid"> Sign In with Google
        </button>
        <button mat-button class="facebook">
            <img src="../../../assets/b2c/hotel/facebook.png" class="img-fluid"> Sign In with Facebook
        </button>
    </div> -->
</section>
<app-common-loader *appLoader="isLoading" [content]="'Register'"></app-common-loader>
